import { COLLAB_ROLES, USER_TYPES } from "@/constants/board";

/**
 * 是否是原创画板
 */
export function isOriginalBoard(board: IBoardInfo) {
  return board?.extra?.is_creation;
}

/**
 * 是否是带归类画板
 */
export function isWaitClassifyBoard(board: IBoardInfo) {
  return board?.is_private === 2;
}

// 获取用户类型
export function getUserType(loginUserId, board, members) {
  // 1. 检查是否为创建者
  if (board.user_id === loginUserId) {
    return USER_TYPES.CREATOR;
  }

  // 2. 检查是否为协作成员
  const member = members.find((member) => member.user_id === loginUserId);

  if (member) {
    if (member.status === 1) {
      return USER_TYPES.COLLABORATOR;
    } else if (member.status === 0 && member.inviter_user_id) {
      return USER_TYPES.INVITED;
    }
  }

  return USER_TYPES.VISITOR;
}

export function canCollabBoardMng(board: IBoardInfo, currentUser: IUser) {
  return (
    isCollabBoardMember(board, currentUser) ||
    (board?.user_id && currentUser?.user_id === board?.user_id)
  );
}

export function isCollabBoardMember(board: IBoardInfo, currentUser: IUser) {
  return (
    (board?.user_id && board?.user_id === currentUser?.user_id) ||
    board?.is_collab_member
  );
}

export function getBoardType(board: IBoardInfo) {
  // 个人公开，个人隐私，多人公开，多人隐私。
  const pre = board?.extra?.collab ? "多人" : "个人";
  const post = board?.is_private ? "隐私" : "公开";

  return `${pre}${post}`;
}

export function canEditPinFn(pin: IPin | null, currentUser: IUser) {
  if (!pin || !currentUser) {
    return false;
  }

  const isOwner = (pin.user?.user_id || pin.user_id) === currentUser.user_id;
  const isEditorBoard = pin.board?.extra?.collab === COLLAB_ROLES.EDITOR;
  const isMember = pin.is_collab_member || pin.board?.is_collab_member;

  const isBoardOwner = pin.board?.user_id === currentUser.user_id;

  return isOwner || (isEditorBoard && isMember) || isBoardOwner;
}
